import { z } from "zod/v4";

export const GetStayAiSubscriptionPlanGroupsResponseBodySchema = z.object({
  subscriptionPlanGroups: z.any().array(),
});

export type GetStayAiSubscriptionPlanGroupsResponseBodyType = z.infer<
  typeof GetStayAiSubscriptionPlanGroupsResponseBodySchema
>;
